/** PDF/HTML table of contents — anchor ids match chart blocks in dashboardReportHtml.js */

export function getReportChartAnchor(chartId) {
  return `widget-${chartId}`
}

export function buildDashboardReportIndexEntries(sections = []) {
  const entries = []
  sections.forEach((section) => {
    if (!section.charts?.length) return
    entries.push({
      anchor: getReportChartAnchor(section.charts[0].id),
      label: section.label,
      isSection: true,
    })
    section.charts.forEach((chart) => {
      entries.push({
        anchor: getReportChartAnchor(chart.id),
        label: chart.label,
        isChild: true,
      })
    })
  })
  return entries
}

export function renderDashboardReportIndexHtml(entries = [], headerHtml = "") {
  if (!entries.length && !headerHtml) return ""
  const items = entries
    .map(
      (entry) =>
        `<li class="report-index-item${entry.isSection ? " report-index-item--section" : ""}${entry.isChild ? " report-index-item--child" : ""}">
        <a class="report-index-label" href="#${entry.anchor}">${entry.label}</a>
      </li>`,
    )
    .join("")
  const contentsHtml = entries.length
    ? `<h2 class="report-index-title">Contents</h2>
      <p class="report-index-note">Click a chart name to jump to that section in the PDF.</p>
      <ul class="report-index-list">${items}</ul>`
    : ""
  return `
    <div class="report-index report-pdf-block report-pdf-block--index">
      ${headerHtml}
      ${contentsHtml}
    </div>`
}
